/*
 * @Author: liukeke liukeke@diynova.com
 * @Date: 2022-08-07 14:17:35
 * @LastEditors: liukeke liukeke@diynova.com
 * @LastEditTime: 2022-09-13 11:33:56
 * @FilePath: /newtonproject-org-website-2.0/newton-website/src/components/seo.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Helmet } from 'react-helmet'
import { SeochildProps } from '../model/PageModel'
import { useIntl } from 'gatsby-plugin-intl-v6'

const Seo: React.FC<SeochildProps> = props => {
  const intl = useIntl()
  const {
    title = 'AB DAO',
    description = intl.formatMessage({ id: 'pageDescription' }),
    meta = [],
    lang = intl.locale
  } = props
  const rLang = useMemo(() => lang || intl.locale || 'en', [lang, intl.locale])
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)
  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{ lang: rLang }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: 'title',
          content: title
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'twitter:title',
          content: title
        },
        {
          name: 'description',
          content: metaDescription
        },
        {
          name: 'og:description',
          content: metaDescription
        },
        {
          name: 'twitter:description',
          content: metaDescription
        },
        {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover'
        },
        {
          name: 'wechat-enable-text-zoom-em',
          content: 'false'
        },
        {
          name: 'format-detection',
          content: 'telephone=no'
        },
        ...meta
      ]}
    />
  )
}
export default Seo
